import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import UserForm, { UserFormFields } from '../../components/User/UserForm';
import api from '../../services/api';
import { useAuth } from '../../contexts/auth';

export default function UsersNew() {
  const {
    user: { organization },
  } = useAuth();
  const navigate = useNavigate();
  const [formErrors, setFormErrors] = useState({});

  const onSubmit = async (data: UserFormFields) => {
    try {
      await api.post(`admin/organizations/${organization.id}/users`, data);

      navigate('/admin/users');
    } catch (e: any) {
      if (e.response.data.errors) {
        setFormErrors(e.response.data.errors);
      }
    }
  };

  const [formFields, setFormFields] = useState<UserFormFields>(
    {} as UserFormFields
  );

  return (
    <UserForm
      isLoading={false}
      title='Novo'
      formFields={formFields}
      formErrors={formErrors}
      onSubmit={onSubmit}
    />
  );
}
